module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACCSURBVDiNvdM7EsMgDEXRi9dEXCt12BPJntzLdRYV3DidAcm/V8LozIAkuDIxqYxJ356aoXIopZA92Cb0gxnAg4XaRUwqoaAAIfD5Ts8mWIX+ebxUAelhXciKmSALZoZ62GbX9uTep53y2Yfbvw5ktiBVyDvV0FhaD9JMTCqHgL1ZALnUR1IIrYk0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-right-blue.png
// module id = g90L
// module chunks = 0